<template>
  <sui-form-field :width="field.width || width || 16" :required="field.required" :error="isInvalid" v-if="field && !field.hidden">
    <label v-show="field.label">
      {{field.label}}
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="field.warning" v-if="field.warning"><i class="warning sign yellow fitted icon" /></span>
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="tooltip" v-if="tooltip"><i class="help circle blue fitted icon" /></span>
    </label>
    <sui-input v-model.trim="$attrs.value" :icon="icon" :disabled="field.readonly" :placeholder="fieldPlaceholder" @input="onInput" v-if="!options" />
    <sui-dropdown :class="{disabled: isDisabled}" search selection :loading="loading" :multiple="field.multiple || false" :allowAdditions="field.allowAdditions || false" :options="options" :placeholder="fieldPlaceholder" ref="dropdown" v-model="$attrs.value" @change="onChange" @input="onInput" v-if="options" />
    <small v-if="description">
      {{description}}
    </small>
    <small class="errors">
      {{error}}
    </small>
    <small v-if="field.examples && !field.readonly">
      Example{{field.examples.length > 1 ? 's' : ''}}:
      <span class="example" v-for="example in field.examples" :key="example" @click.prevent="set([example])">{{example}}</span>
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'
  export default {
    name: 'FormEntityDropdown',
    mixins: [
      FormField,
    ],
    props: {
      description: {
        type: String,
        required: false,
        default: '',
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
      options: {
        default: null,
      },
    },
    computed: {
      isDisabled() {
        return this.field.readonly || (!this.options.length && !this.field.allowAdditions)
      },
      fieldPlaceholder() {
        const textPlaceholder = this.field.placeholder || ''
        const dropdownPlaceholder = (this.options && this.options.length) ? (this.field.placeholder || 'Select...') : (this.field.placeholderEmpty || 'No available options')
        return this.placeholder || (this.fieldType === 'dropdown' ? dropdownPlaceholder : textPlaceholder)
      }
    },
    methods: {
      onChange() {
        // wait onInput and remove filter if it hasn't been removed
        setTimeout(() => {
          this.$refs.dropdown.filter = ''
        }, 100)
      },
    }
  }
</script>

<style scoped>
  .tooltip { float: right; }
  .example { margin-left: .1em; color: #48c; cursor: pointer; }
  .example:after { content: ", "; color: #000; }
  .example:hover { color: #6ae; }
  .example:last-child:after { content: ""; }
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
</style>
